import RequestStatus from "../model/RequestStatus";
import {ProductInfo} from "src/model/ProductMatch";

export const BULK_PRODUCTS_QUERY_START = 'BULK_PRODUCTS_QUERY_START';
export const BULK_PRODUCTS_QUERY_NOT_LOADED = 'BULK_PRODUCTS_QUERY_NOT_LOADED';
export const BULK_PRODUCTS_QUERY_SUCCESS = 'BULK_PRODUCTS_QUERY_SUCCESS';
export const BULK_PRODUCTS_QUERY_FAILED = 'BULK_PRODUCTS_QUERY_FAILED';

export interface BulkProductsReportQueryStartAction {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly countryCode: string;
    readonly products: Array<ProductInfo>;
}

export const setBulkProductsQueryStart = (countryCode: string, products: Array<ProductInfo>): BulkProductsReportQueryStartAction => ({
    type: BULK_PRODUCTS_QUERY_START,
    requestStatus: RequestStatus.LOADING,
    countryCode: countryCode,
    products: products,
});

export const setBulkProductsQueryClear = (): BulkProductsReportQueryStartAction => ({
    type: BULK_PRODUCTS_QUERY_NOT_LOADED,
    requestStatus: RequestStatus.NOT_LOADED,
    countryCode: "",
    products: [],
});

export interface GetBulkProductsQueryComplete {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly report: any;
}

export const getBulkProductsQuerySuccessAction = (report: Array<Array<string>>): GetBulkProductsQueryComplete => ({
    type: BULK_PRODUCTS_QUERY_SUCCESS,
    requestStatus: RequestStatus.SUCCESS,
    report: report,
});

export const getBulkProductsQueryFailedAction = (): GetBulkProductsQueryComplete => ({
    type: BULK_PRODUCTS_QUERY_FAILED,
    requestStatus: RequestStatus.ERROR,
    report: null
});
